import { Repository } from "./adapters/repository";
import { Workspace } from "./adapters/workspace";

import * as retrievePlanzones from "./useCases/retrievePlanzones";
import * as changePlanzone from "./useCases/changePlanzone";
import * as retrieveCurrentPlanzone from "./useCases/retrieveCurrentPlanzone";
import * as retrievePersonalSynthesis from "./useCases/retrievePersonalSynthesis";
import * as updatePlanzoneContacts from "./useCases/updatePlanzoneContacts";
import * as retrieveOrganization from "./useCases/retrieveOrganization";
import * as editOrganization from "./useCases/editOrganization";
import * as retrievePlanzoneSettings from "./useCases/retrievePlanzoneSettings";
import * as editPlanzoneSettings from "./useCases/editPlanzoneSettings";
import * as retrieveWbsConfiguration from "./useCases/retrieveWbsConfiguration";
import * as editWbsConfiguration from "./useCases/editWbsConfiguration";
import * as retrieveProjectElementDetailsConfiguration from "./useCases/retrieveProjectElementDetailsConfiguration";
import * as retrieveProjectListingConfiguration from "./useCases/retrieveProjectListingConfiguration";
import * as editProjectListingConfiguration from "./useCases/editProjectListingConfiguration";
import * as retrieveResourcesListingConfiguration from "./useCases/retrieveResourcesListingConfiguration";
import * as editResourcesListingConfiguration from "./useCases/editResourcesListingConfiguration";
import * as retrieveTimeRecordsListingConfiguration from "./useCases/retrieveTimeRecordsListingConfiguration";
import * as editTimeRecordsListingConfiguration from "./useCases/editTimeRecordsListingConfiguration";
import * as retrieveProjectMembersListingConfiguration from "./useCases/retrieveProjectMembersListingConfiguration";
import * as editProjectMembersListingConfiguration from "./useCases/editProjectMembersListingConfiguration";
import * as assignDefaultCalendarHolidaysToPlanzone from "./useCases/assignDefaultCalendarHolidaysToPlanzone";
import * as retrieveDefaultCalendarHolidays from "./useCases/retrieveDefaultCalendarHolidays";
import * as editProjectElementDetailsConfiguration from "./useCases/editProjectElementDetailsConfiguration";
import * as retrieveProjectDetailsConfiguration from "./useCases/retrieveProjectDetailsConfiguration";
import * as editProjectDetailsConfiguration from "./useCases/editProjectDetailsConfiguration";
import * as changePlanzoneLogo from "./useCases/changePlanzoneLogo";
import * as addIdentityProvider from "./useCases/addIdentityProvider";
import * as retrieveIdentityProviders from "./useCases/retrieveIdentityProviders";
import * as removeIdentityProvider from "./useCases/removeIdentityProvider";
import * as editIdentityProvider from "./useCases/editIdentityProvider";
import * as retrieveResourceDetailsConfiguration from "./useCases/retrieveResourceDetailsConfiguration";
import * as editResourceDetailsConfiguration from "./useCases/editResourceDetailsConfiguration";
import * as editTimesheetDeadline from "./useCases/editTimesheetDeadline";
import * as editAllocationWarning from "./useCases/editAllocationWarning";

enum UseCases {
  retrievePlanzones = "retrievePlanzones",
  changePlanzone = "changePlanzone",
  retrieveCurrentPlanzone = "retrieveCurrentPlanzone",
  retrievePersonalSynthesis = "retrievePersonalSynthesis",
  updatePlanzoneContacts = "updatePlanzoneContacts",
  retrieveOrganization = "retrieveOrganization",
  editOrganization = "editOrganization",
  retrievePlanzoneSettings = "retrievePlanzoneSettings",
  editPlanzoneSettings = "editPlanzoneSettings",
  retrieveWbsConfiguration = "retrieveWbsConfiguration",
  editWbsConfiguration = "editWbsConfiguration",
  retrieveProjectListingConfiguration = "retrieveProjectListingConfiguration",
  editProjectListingConfiguration = "editProjectListingConfiguration",
  retrieveResourcesListingConfiguration = "retrieveResourcesListingConfiguration",
  editResourcesListingConfiguration = "editResourcesListingConfiguration",
  retrieveTimeRecordsListingConfiguration = "retrieveTimeRecordsListingConfiguration",
  editTimeRecordsListingConfiguration = "editTimeRecordsListingConfiguration",
  retrieveProjectMembersListingConfiguration = "retrieveProjectMembersListingConfiguration",
  editProjectMembersListingConfiguration = "editProjectMembersListingConfiguration",
  assignDefaultCalendarHolidaysToPlanzone = "assignDefaultCalendarHolidaysToPlanzone",
  retrieveDefaultCalendarHolidays = "retrieveDefaultCalendarHolidays",
  retrieveProjectElementDetailsConfiguration = "retrieveProjectElementDetailsConfiguration",
  editProjectElementDetailsConfiguration = "editProjectElementDetailsConfiguration",
  retrieveProjectDetailsConfiguration = "retrieveProjectDetailsConfiguration",
  editProjectDetailsConfiguration = "editProjectDetailsConfiguration",
  changePlanzoneLogo = "changePlanzoneLogo",
  addIdentityProvider = "addIdentityProvider",
  retrieveIdentityProviders = "retrieveIdentityProviders",
  removeIdentityProvider = "removeIdentityProvider",
  editIdentityProvider = "editIdentityProvider",
  retrieveResourceDetailsConfiguration = "retrieveResourceDetailsConfiguration",
  editResourceDetailsConfiguration = "editResourceDetailsConfiguration",
  editTimesheetDeadline = "editTimesheetDeadline",
  editAllocationWarning = "editAllocationWarning",
}

interface Core {
  [UseCases.retrievePlanzones]: retrievePlanzones.Interactor;
  [UseCases.changePlanzone]: changePlanzone.Interactor;
  [UseCases.retrieveCurrentPlanzone]: retrieveCurrentPlanzone.Interactor;
  [UseCases.retrievePersonalSynthesis]: retrievePersonalSynthesis.Interactor;
  [UseCases.updatePlanzoneContacts]: updatePlanzoneContacts.Interactor;
  [UseCases.retrieveOrganization]: retrieveOrganization.Interactor;
  [UseCases.editOrganization]: editOrganization.Interactor;
  [UseCases.retrievePlanzoneSettings]: retrievePlanzoneSettings.Interactor;
  [UseCases.editPlanzoneSettings]: editPlanzoneSettings.Interactor;
  [UseCases.retrieveWbsConfiguration]: retrieveWbsConfiguration.Interactor;
  [UseCases.editWbsConfiguration]: editWbsConfiguration.Interactor;
  [UseCases.retrieveProjectListingConfiguration]: retrieveProjectListingConfiguration.Interactor;
  [UseCases.editProjectListingConfiguration]: editProjectListingConfiguration.Interactor;
  [UseCases.retrieveResourcesListingConfiguration]: retrieveResourcesListingConfiguration.Interactor;
  [UseCases.editResourcesListingConfiguration]: editResourcesListingConfiguration.Interactor;
  [UseCases.retrieveTimeRecordsListingConfiguration]: retrieveTimeRecordsListingConfiguration.Interactor;
  [UseCases.editTimeRecordsListingConfiguration]: editTimeRecordsListingConfiguration.Interactor;
  [UseCases.retrieveProjectMembersListingConfiguration]: retrieveProjectMembersListingConfiguration.Interactor;
  [UseCases.editProjectMembersListingConfiguration]: editProjectMembersListingConfiguration.Interactor;
  [UseCases.assignDefaultCalendarHolidaysToPlanzone]: assignDefaultCalendarHolidaysToPlanzone.Interactor;
  [UseCases.retrieveDefaultCalendarHolidays]: retrieveDefaultCalendarHolidays.Interactor;
  [UseCases.retrieveProjectElementDetailsConfiguration]: retrieveProjectElementDetailsConfiguration.Interactor;
  [UseCases.editProjectElementDetailsConfiguration]: editProjectElementDetailsConfiguration.Interactor;
  [UseCases.retrieveProjectDetailsConfiguration]: retrieveProjectDetailsConfiguration.Interactor;
  [UseCases.editProjectDetailsConfiguration]: editProjectDetailsConfiguration.Interactor;
  [UseCases.changePlanzoneLogo]: changePlanzoneLogo.Interactor;
  [UseCases.addIdentityProvider]: addIdentityProvider.Interactor;
  [UseCases.retrieveIdentityProviders]: retrieveIdentityProviders.Interactor;
  [UseCases.removeIdentityProvider]: removeIdentityProvider.Interactor;
  [UseCases.editIdentityProvider]: editIdentityProvider.Interactor;
  [UseCases.retrieveResourceDetailsConfiguration]: retrieveResourceDetailsConfiguration.Interactor;
  [UseCases.editResourceDetailsConfiguration]: editResourceDetailsConfiguration.Interactor;
  [UseCases.editTimesheetDeadline]: editTimesheetDeadline.Interactor;
  [UseCases.editAllocationWarning]: editAllocationWarning.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
  workspace: Workspace;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrievePlanzones]: retrievePlanzones.createInteractor(
      dependencies.repository,
    ),
    [UseCases.changePlanzone]: changePlanzone.createInteractor(
      dependencies.workspace,
      dependencies.repository,
    ),
    [UseCases.retrieveCurrentPlanzone]:
      retrieveCurrentPlanzone.createInteractor(dependencies.workspace),
    [UseCases.retrievePersonalSynthesis]:
      retrievePersonalSynthesis.createInteractor(dependencies.repository),
    [UseCases.updatePlanzoneContacts]: updatePlanzoneContacts.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveOrganization]: retrieveOrganization.createInteractor(
      dependencies.repository,
    ),
    [UseCases.editOrganization]: editOrganization.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrievePlanzoneSettings]:
      retrievePlanzoneSettings.createInteractor(dependencies.repository),
    [UseCases.editPlanzoneSettings]: editPlanzoneSettings.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveWbsConfiguration]:
      retrieveWbsConfiguration.createInteractor(dependencies.repository),
    [UseCases.editWbsConfiguration]: editWbsConfiguration.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveProjectListingConfiguration]:
      retrieveProjectListingConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.editProjectListingConfiguration]:
      editProjectListingConfiguration.createInteractor(dependencies.repository),
    [UseCases.retrieveResourcesListingConfiguration]:
      retrieveResourcesListingConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.editResourcesListingConfiguration]:
      editResourcesListingConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.retrieveTimeRecordsListingConfiguration]:
      retrieveTimeRecordsListingConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.editTimeRecordsListingConfiguration]:
      editTimeRecordsListingConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.retrieveProjectMembersListingConfiguration]:
      retrieveProjectMembersListingConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.editProjectMembersListingConfiguration]:
      editProjectMembersListingConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.assignDefaultCalendarHolidaysToPlanzone]:
      assignDefaultCalendarHolidaysToPlanzone.createInteractor(
        dependencies.repository,
      ),
    [UseCases.retrieveDefaultCalendarHolidays]:
      retrieveDefaultCalendarHolidays.createInteractor(dependencies.repository),
    [UseCases.retrieveProjectElementDetailsConfiguration]:
      retrieveProjectElementDetailsConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.editProjectElementDetailsConfiguration]:
      editProjectElementDetailsConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.retrieveProjectDetailsConfiguration]:
      retrieveProjectDetailsConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.editProjectDetailsConfiguration]:
      editProjectDetailsConfiguration.createInteractor(dependencies.repository),
    [UseCases.changePlanzoneLogo]: changePlanzoneLogo.createInteractor(
      dependencies.repository,
    ),
    [UseCases.addIdentityProvider]: addIdentityProvider.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveIdentityProviders]:
      retrieveIdentityProviders.createInteractor(dependencies.repository),
    [UseCases.removeIdentityProvider]: removeIdentityProvider.createInteractor(
      dependencies.repository,
    ),
    [UseCases.editIdentityProvider]: editIdentityProvider.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveResourceDetailsConfiguration]:
      retrieveResourceDetailsConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.editResourceDetailsConfiguration]:
      editResourceDetailsConfiguration.createInteractor(
        dependencies.repository,
      ),
    [UseCases.editTimesheetDeadline]: editTimesheetDeadline.createInteractor(
      dependencies.repository,
    ),
    [UseCases.editAllocationWarning]: editAllocationWarning.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
